import { CATEGORY_KEYS, EMPTY_PIE, pctOfTotal, allocateRoundedPercentages, safeNumber } from './dataQuality.helpers';
export function buildPieBreakdown(rows = [], keys = CATEGORY_KEYS) {
  const totals = Object.fromEntries(keys.map((k) => [k, 0]));
  for (const row of Array.isArray(rows) ? rows : []) {
    for (const k of keys) totals[k] += safeNumber(row?.[k]);
  }
  const grand = keys.reduce((s, k) => s + totals[k], 0);
  if (!grand) return { seriesDecimals: EMPTY_PIE, seriesDisplayInts: EMPTY_PIE };
  const decimalsByKey = Object.fromEntries(keys.map((k) => [k, pctOfTotal(totals[k], grand)]));
  const displayByKey = allocateRoundedPercentages(decimalsByKey);
  return {
    seriesDecimals: keys.map((k) => ({ name: k, value: decimalsByKey[k] })),
    seriesDisplayInts: keys.map((k) => ({ name: k, value: displayByKey[k] })),
  };
}
